<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>合同流程信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 检索 -->
            <el-form :model="listQuery" :inline="true">
                <el-form-item label="合同名称">
                  <el-input v-model="listQuery.contractName" placeholder filterable clearable></el-input>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="listQuery.name" placeholder filterable clearable></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="listQuery.tel" placeholder filterable clearable></el-input>
                </el-form-item>
                <el-form-item label="签署状态">
                    <el-select v-model="listQuery.state" placeholder="" filterable clearable>
                        <el-option value="1" label="未签署"></el-option>
                        <el-option value="2" label="签署中"></el-option>
                        <el-option value="3" label="已签署"></el-option>
                        <el-option value="4" label="已取消"></el-option>
<!--                        <el-option value="5" label="已归档"></el-option>-->
                        <el-option value="6" label="审核中"></el-option>
                    </el-select>
                </el-form-item>

                <el-button type="primary" @click="clickSearch">查询</el-button>
            </el-form>

            <!-- 列表数据 -->
            <el-table :data="processListData" border style="width: 100%" class="table">
                <el-table-column prop="processId" label="流程ID"></el-table-column>
                <el-table-column prop="contractNo" label="合同编号"></el-table-column>
                <el-table-column prop="signName" label="姓名（甲方）">
                  <template slot-scope="scope">
                   {{  scope.row.companyName!='' ?scope.row.companyName+"("+scope.row.signName+")" : scope.row.signName}}
                  </template>
                </el-table-column>
                <el-table-column prop="tel" label="电话（甲方）"></el-table-column>
                <el-table-column prop="signNameTwo" label="姓名（乙方）">
                  <template slot-scope="scope">
                    {{scope.row.companyNameTwo!=''?scope.row.companyNameTwo+"("+scope.row.signNameTwo+")" : scope.row.signNameTwo}}
                  </template>
                </el-table-column>
                <el-table-column prop="telTwo" label="电话（乙方）"></el-table-column>
                <el-table-column prop="signNameThree" label="姓名（丙方）">
                  <template slot-scope="scope">
                    {{scope.row.companyNameThree!='' ?scope.row.companyNameThree+"("+scope.row.signNameThree+")" : scope.row.signNameThree}}
                  </template>
                </el-table-column>
                <el-table-column prop="telThree" label="电话（丙方）"></el-table-column>


                <el-table-column prop="contractName" label="合同名称">
                </el-table-column>
                <el-table-column prop="state" label="签署状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state == 1">未签署</el-tag>
                        <el-tag v-if="scope.row.state == 2" type="info">签署中</el-tag>
                        <el-tag v-if="scope.row.state == 3" type="success">已签署</el-tag>
                        <el-tag v-if="scope.row.state == 4" type="danger">已取消</el-tag>
                        <el-tag v-if="scope.row.state == 5" type="success">已签署</el-tag>
                        <el-tag v-if="scope.row.state == 6" type="warning">审核中</el-tag>
                        <!-- <el-tag v-if="scope.row.state == 3">已取消</el-tag> -->
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="发起时间" :formatter="dateFormatA"></el-table-column>

                <el-table-column prop="creatorName" label="操作" fixed="right" width="250px">
                    <template slot-scope="scope">

                        <el-button type="text" @click="checkSignAdressBtn(scope.row)">查看签约地址</el-button>
                        <el-button type="text" @click="previewBtn(scope.$index, scope.row)"
                            v-loading.fullscreen.lock="fullscreenLoading">预览
                        </el-button>

                      <el-button v-if="scope.row.state==1 || scope.row.state==2" type="text" @click="toSign(scope.row)">催签
                      </el-button>
                      <el-button v-if="scope.row.state==1" type="text" @click="cancelSign(scope.row)">取消
                      </el-button>
                        <!-- <el-button type="text" @click="cancelSign(scope.row)" class="textWarning"
                            v-if="scope.row.state == 1 && (scope.row.type == 105 || scope.row.type == 110)">取消
                        </el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页  -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <!-- 签约地址 -->
        <signAdressDia ref="signAdressDiaRef" />
    </div>
</template>
<script>
import Pagination from "@/components/common/Pagination";
import globalData from "@/components/common/globaldata/global.data.vue";
// import contractprocedure from '@/script/api/contractprocedure';
import contractApi from "@/script/api/contractapi";
import contractConfigApi from "@/script/api/contractConfigApi";



import signAdressDia from '@/components/contract/compent/signAdressDia';

export default {
    components: {
        Pagination,signAdressDia
    },
    data() {
        return {
            showSign: false,
            PDFVisible: false,
            contractUrl: "",

            fullscreenLoading: false,
            processListData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                name: "",
                tel: "",
                state: null,
                contractName: null,
            },
            singList: [],

        };
    },
    created() {
        this.querySearch();
    },
    methods: {
        checkSignAdressBtn(row) {
            //查看签署地址
            this.$refs.signAdressDiaRef.signAdressDiaRow(row);
        },
        clickSearch() {
            this.currentPage = 1;
            this.querySearch();
        },
        // exportExcel() {
        //     let reqData = {
        //         name: this.listQuery.name,
        //         tel: this.listQuery.tel,
        //         state: this.listQuery.state,
        //         type: this.listQuery.type,
        //         isExport: true,
        //         userId: globalData.userInfo.id,
        //     };
        //     contract.$download(reqData, "合同数据明细");
        // },
        //查询
        querySearch() {
            let reqData = {
                name: this.listQuery.name,
                tel: this.listQuery.tel,
                state: this.listQuery.state,
                contractName: this.listQuery.contractName,
                pageNo: this.currentPage,
                pageSize: this.pageSize,
            };
          contractConfigApi.$ajaxContractprocedureinfoGetPageList(reqData).then((res) => {
                if (res.data.errno == 0) {
                    this.total = res.data.data.total;
                    this.processListData = res.data.data.list;
                }
            });
        },
        //预览
        previewBtn(index, row) {
            this.fullscreenLoading = true;
            contractApi
                .$ajaxselectContractFile({
                    procedureId: row.processId,
                })
                .then((res) => {
                    if (res.data.errno == 0) {
                        window.open(
                            "/static/pdf/web/viewer.html?file=" +
                            encodeURIComponent(res.data.data.downloadUrl)
                        );
                        this.fullscreenLoading = false;
                    }
                });
        },
        //   取消
        cancelSign(row) {
            this.$confirm("是否确定取消?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    contractConfigApi.$ajaxCancelSignNew({
                        processId: row.processId,
                    })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("取消成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => { });

        },
      //催签
      toSign(row){
        contractApi
          .$ajaxRushsignContract({
            procedureId: row.processId,
          })
          .then((res) => {
            if (res.data.errno == 0) {
              //console.log("cs==="+res.data)
              this.$message.success("催签成功");
            }
          });
      }



    },
};
</script>
<style scoped>
.person-dialog .el-select {
    width: 300px;

}

.person-dialog .el-dialog__body {
    height: 160px;

}
</style>
